import api from '../../utils/api';
import router from '../../router';

// initial state
const state = {
    isLoaded: false,
    items: []
};

// mutations
const mutations = {
    loading(state) {
        state.isLoaded = false;
    },
    loaded(state) {
        state.isLoaded = true;
    },
    items(state, items) {
        state.items = items;
    }
};

// getters
const getters = {
};

// actions
const actions = {
    getItems(store) {
        store.commit('loading');
        api.get('/api/list/').then(function(response) {
                store.commit('items', response.body);
                store.commit('loaded');
            },
            function() {
                store.commit('loaded');
            });
    },
    back() {
        router.push({
            name: 'dashboard'
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/list.js